// Test IDs for Adventures of Black Emigo game UI
export const GAME = {
  startBtn: "start-button",
  leaderboardBtn: "leaderboard-button",
  backToTitleBtn: "back-to-title-button",
  restartBtn: "restart-button",
  submitScoreBtn: "submit-score-button",
  playerNameInput: "player-name-input",
  pauseBtn: "pause-button",
  resumeBtn: "resume-button",
  scoreDisplay: "score-display",
  livesDisplay: "lives-display",
  blockDisplay: "block-display",
  gameCanvas: "game-canvas",
  titleScreen: "title-screen",
  gameOverModal: "game-over-modal",
  leaderboardScreen: "leaderboard-screen",
  leaderboardRow: "leaderboard-row",
  spotifyEmbed: "spotify-embed",
};
